import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Formik
import { Form, Formik } from 'formik';

// Helpers
import Helpers from '../helpers';

// Components
import FunctionalTextInput from './Inputs/FunctionalInput';
import FunctionalButton from './Buttons/FunctionalButton';

// Interfaces
interface Features {
    message?: string;
    AuthStore?: any;
    LanguageStore?: any;
    StoreStore?: any;
}

@inject('AuthStore', 'LanguageStore', 'StoreStore')
@observer

export default class LoginForm extends React.Component<Features> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {

    }

    render() {
        const storeId: any = localStorage.getItem('storeId');

        let storeLogo: any = null;
        if (this.props.StoreStore.stores[storeId] !== undefined) {
            const storeData = this.props.StoreStore.stores[storeId];
            storeLogo = storeData.logo.data !== null ? Helpers.getMediumImageUrl(storeData.logo.data.attributes) : null;
        }

        return (
            <section className="bg-white flex flex-col justify-center items-center py-8">
                {
                    storeLogo !== undefined &&
                    <img
                        src={storeLogo}
                        className="w-48 lg:w-64"
                    />
                }

                <div className="container mx-auto">
                    <div className="flex flex-col justify-center items-center md:flex-row gap-4">
                        {/* Login Section */}
                        <div className="md:w-1/2 bg-white rounded-lg shadow-md p-10">
                            <h2 className="text-2xl font-semibold mb-4">{Helpers.translation('login')}</h2>

                            {
                                this.props.message !== undefined &&
                                <div className="mb-4">{this.props.message}</div>
                            }

                            <Formik
                                initialValues={{ username: "", password: "" }}
                                validationSchema={Helpers.createValidationSchema([
                                    'username',
                                    'password',
                                ])}
                                onSubmit={(values: any) => Helpers.login(values)}
                            >
                                {({ errors }: any) => (
                                    <Form className="w-full">
                                        <FunctionalTextInput
                                            name="username"
                                            placeholder={Helpers.translation('username')}
                                            label={Helpers.translation('username')}
                                            errors={errors.username}
                                            frameClasses="mb-4"
                                        />

                                        <FunctionalTextInput
                                            name="password"
                                            placeholder={Helpers.translation('password')}
                                            label={Helpers.translation('password')}
                                            errors={errors.password}
                                            secureTextStatus
                                            frameClasses="mb-4"
                                        />

                                        <FunctionalButton
                                            text={Helpers.translation('login')}
                                            textColor="text-white"
                                            rounded
                                        />
                                    </Form>
                                )
                                }
                            </Formik>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}